import { createPermission } from '@backstage/plugin-permission-common';

export const environmentManagerAdminPermission = createPermission({
  name: 'environment-manager.admin',
  attributes: {},
});
